import React from "react";
import Redrecord from "./Redrecord";
import Greenrecod from "./Greenrecod";
import Bluehalf from "./Bluehalf";
import "./Record.css";
import Redrecord1 from "./Redrecord1";
const Record = ({ biddatafast,period1}) => {

 
  
  return (
    <>
     <div>
        {/*  here is 1 file  ciecles*/}
        <div
        className="center-record" >
         
         <Redrecord1   bgcolor={"orange"} numresult={"?"} period={period1} />
         {biddatafast &&
            biddatafast.reverse().slice(0, 30).map((item) => {
              return (
                <> 
                  <div  style={{ width: "3px" }}></div>
                  
                  <Redrecord bgcolor={item.result} numresult={item.number} period={item.period} />
                </>
              );
            })}
             <div  style={{ width: "3px" }}></div>
          
       
        </div>
      
       
      </div>
    </>
  );
};

export default Record;
